import React, { useState } from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { X } from 'lucide-react';

export function Banner({
    text,
    boldText,
    textColor = 'white',
    backgroundColor = '#009966',
    borderColor = '#009966',
    dismissable = false,
    onDismiss,
    showButton = false,
    buttonText = 'See details',
    onButtonClick
}) {
    const [visible, setVisible] = useState(true);

    const handleDismiss = () => {
        setVisible(false);
        if (onDismiss) {
            onDismiss();
        }
    };

    if (!visible) {
        return null;
    }

    return (
        <Box
            sx={{
                bgcolor: backgroundColor,
                border: `1px solid ${borderColor}`,
                borderRadius: 2,
                display: 'flex',
                flexWrap: 'wrap',
                gap: 2,
                alignItems: 'center',
                pl: 2,
                pr: 1.25,
                py: 1.25
            }}
        >
            {/* Text Content */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                    sx={{
                        fontSize: '13px',
                        lineHeight: '20px',
                        color: textColor
                    }}
                >
                    {boldText && (
                        <Box component="span" sx={{ fontWeight: 600 }}>
                            {boldText}{' '}
                        </Box>
                    )}
                    <Box component="span" sx={{ fontWeight: 400 }}>
                        {text}
                    </Box>
                </Typography>
            </Box>

            {/* See Details Button */}
            {showButton && (
                <Button
                    onClick={onButtonClick}
                    sx={{
                        bgcolor: 'white',
                        color: '#212322',
                        border: '1px solid #d9d9d9',
                        borderRadius: 2,
                        px: 1.25,
                        py: 0.625,
                        fontSize: '13px',
                        textTransform: 'none',
                        lineHeight: '22px',
                        boxShadow: '0px 2px 0px 0px rgba(0,0,0,0.02)',
                        flexShrink: 0,
                        '&:hover': {
                            bgcolor: '#fafafa',
                            border: '1px solid #d9d9d9'
                        }
                    }}
                >
                    {buttonText}
                </Button>
            )}

            {/* Dismiss Button */}
            {dismissable && (
                <IconButton
                    onClick={handleDismiss}
                    size="small"
                    sx={{
                        color: 'white',
                        p: 0,
                        flexShrink: 0
                    }}
                >
                    <X size={20} strokeWidth={1.3} />
                </IconButton>
            )}
        </Box>
    );
}
